var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "fade-modal"
    }
  }, [_vm.value ? _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "panel",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "header"
  }, [_vm.title ? _c('Title', {
    attrs: {
      "title": _vm.title,
      "titleAlign": _vm.titleAlign
    }
  }) : _vm._e()], 1), _vm._t("default")], 2)]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };